import React, { useState } from 'react';
import { PhoneIcon, MapPinIcon, ClockIcon, MailIcon } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contact" className="py-20 bg-white" data-id="element-401">
      <div className="container mx-auto px-4" data-id="element-402">
        <div className="max-w-5xl mx-auto" data-id="element-403">
          <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center border-b-4 border-[#B1050B] pb-4 inline-block w-full" data-id="element-404">
            Contact Us
          </h2>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-405">
            {/* Left Column: Get In Touch */}
            <div data-id="element-406">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 border-l-4 border-black pl-4" data-id="element-407">
                Get In Touch
              </h3>
              <div className="space-y-6" data-id="element-408">
                <div className="flex items-start border-l-2 border-[#B1050B] pl-4" data-id="element-409">
                  <PhoneIcon size={24} className="text-[#B1050B] mr-4 mt-1" data-id="element-410" />
                  <div data-id="element-411">
                    <h4 className="font-bold text-gray-900 mb-1" data-id="element-412">
                      Call or Text
                    </h4>
                    <a href="tel:2484788382" className="text-[#B1050B] hover:text-[#8A0408] text-lg transition-colors" data-id="element-413">
                      (248) 478-8382
                    </a>
                  </div>
                </div>
                <div className="flex items-start border-l-2 border-[#B1050B] pl-4" data-id="element-414">
                  <MapPinIcon size={24} className="text-[#B1050B] mr-4 mt-1" data-id="element-415" />
                  <div data-id="element-416">
                    <h4 className="font-bold text-gray-900 mb-1" data-id="element-417">Address</h4>
                    <a href="https://maps.google.com/?q=24175+Industrial+Park+Dr.,+Farmington+Hills,+MI+48335" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-[#B1050B] transition-colors" data-id="element-418">
                      24175 Industrial Park Dr.
                      <br data-id="element-419" />
                      Farmington Hills, MI 48335
                    </a>
                  </div>
                </div>
                <div className="flex items-start border-l-2 border-[#B1050B] pl-4" data-id="element-420">
                  <ClockIcon size={24} className="text-[#B1050B] mr-4 mt-1" data-id="element-421" />
                  <div data-id="element-422">
                    <h4 className="font-bold text-gray-900 mb-1" data-id="element-423">Hours</h4>
                    <div className="text-gray-700" data-id="element-424">
                      <p data-id="element-425">Monday - Friday: 7:00 AM - 4:00 PM</p>
                      <p data-id="element-426">Saturday - Sunday: Closed</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Contact Form */}
            <div data-id="element-427">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 border-l-4 border-black pl-4" data-id="element-428">
                Send Us a Message
              </h3>
              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-429">
                <div data-id="element-430">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-431">
                    Name *
                  </label>
                  <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-#B1050B focus:border-transparent outline-none transition-all" placeholder="Your name" data-id="element-432" />
                </div>

                <div data-id="element-433">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-434">
                    Email *
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-#B1050B focus:border-transparent outline-none transition-all" placeholder="your@email.com" data-id="element-435" />
                </div>

                <div data-id="element-436">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-437">
                    Phone
                  </label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#B1050B] focus:border-transparent outline-none transition-all" placeholder="(248) 123-4567" data-id="element-438" />
                </div>

                <div data-id="element-439">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-440">
                    Message *
                  </label>
                  <textarea id="message" name="message" required value={formData.message} onChange={handleChange} rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#B1050B] focus:border-transparent outline-none transition-all resize-none" placeholder="Tell us about your vehicle and service needs..." data-id="element-441" />
                </div>

                <button type="submit" className="w-full bg-[#B1050B] hover:bg-[#8A0408] text-white px-6 py-3 rounded-lg font-bold transition-colors shadow-md" data-id="element-442">
                  Send Message
                </button>
              </form>
            </div>
          </div>

          {/* Mission Statement - Moved Below */}
          <div className="mt-12 bg-white border-l-4 border-[#B1050B] p-6 rounded shadow-lg max-w-3xl mx-auto" data-id="element-443">
            <h4 className="font-bold mb-3 text-[#B1050B] text-xl" data-id="element-444">
              Our Mission
            </h4>
            <p className="text-gray-700 leading-relaxed" data-id="element-445">
              Garrett Auto & Truck Service is here to serve you by performing
              the highest quality automotive & truck repairs at fair prices,
              using only proven materials of the highest quality. Our service is
              backed by our personal pledge of customer satisfaction.
            </p>
          </div>

          {/* CTA Section */}
          <div className="mt-12 bg-[#B1050B] text-white p-8 rounded-lg text-center border-4 border-[#D4AF37] shadow-lg" data-id="element-446">
            <h3 className="text-2xl font-bold mb-4" data-id="element-447">
              Ready to Schedule Service?
            </h3>
            <p className="text-red-100 mb-6 text-lg" data-id="element-448">
              Call us today or stop by our shop. We're here to help with all
              your automotive and truck repair needs.
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-black text-white hover:bg-gray-900 px-8 py-3 rounded font-bold transition-colors border-2 border-[#D4AF37]" data-id="element-449">
              <PhoneIcon size={20} className="mr-2" data-id="element-450" />
              Call (248) 478-8382
            </a>
          </div>
        </div>
      </div>
    </section>;
}